import React from 'react';
import styled from 'styled-components';

interface Props {
  title: string;
  nohead?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  isRegion?: boolean;
}

const LimitTableFilter = ({
  title,
  nohead = false,
  children,
  isRegion,
}: Props) => {
  return (
    <Wrapper>
      <UserFilterOverlay style={{ marginTop: nohead ? '0' : '40px' }}>
        {/* <TopBlur style={{ marginTop: nohead ? '0' : '40px' }} /> */}
        {/* <TopGradient /> */}
        {/* <BottomCover>  */}
        <img
          src="/assets/images/icon/table_lock.svg"
          alt="lock"
          width={32}
          height={32}
        />
        <TextWrapper>
          <MainText>
            {isRegion ? (
              <>
                이용 중인 멤버십으로
                <br />
                열람할 수 없는 내용입니다.
              </>
            ) : (
              <>
                {title}
                <br />
                멤버십 회원만 열람 가능해요.
              </>
            )}
          </MainText>
          <SubText>
            {isRegion
              ? `현재 보유 멤버십 : 부산`
              : '멤버십을 구매하고 땅집고옥션 서비스를 이용해보세요!'}
          </SubText>
        </TextWrapper>
        <Button onClick={() => (window.location.href = '/payment/plan')}>
          {isRegion ? '멤버십 업그레이드' : '멤버십 보러가기'}
        </Button>
        {/* </BottomCover> */}
      </UserFilterOverlay>
      {children}
    </Wrapper>
  );
};

export default LimitTableFilter;

const Wrapper = styled.div`
  position: relative;
  min-height: 200px;
`;

const UserFilterOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  pointer-events: auto;
  display: flex;
  flex-direction: column;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  backdrop-filter: blur(3px);
  background: linear-gradient(
    to bottom,
    #ffffffcc 0%,
    #ffffff 30%,
    #ffffff 100%
  );
  padding-top: 20px;
`;

const TopBlur = styled.div`
  height: 60px;
  width: 100%;
  backdrop-filter: blur(3px);
  background: linear-gradient(to bottom, #ffffffcc 0%, #ffffff 100%);
`;

const BottomCover = styled.div`
  flex: 1;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const MainText = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #222;
  text-align: center;
`;

const SubText = styled.div`
  font-weight: 500;
  font-size: 13px;
  color: #616161;
  text-align: center;
`;

const Button = styled.button`
  padding: 12px 28px;
  border-radius: 8px;
  background-color: #008aff;
  color: white;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  border: none;
`;
